export function formatUtcToLocal(dateString) {
    if (!dateString) return '';


    const cleanDateString = dateString.includes('Z') ? dateString.replace('.000000Z', 'Z') : dateString + 'Z';

    const date = new Date(cleanDateString);

    if (isNaN(date.getTime())) {

        return '';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
